<ng-container *ngIf="isLoaded && isActive">
  <div class="header-section">

      <div class="container">
        <h1 style="font-size:22.5px;"><adp-label labelKey="TechServices_Title"></adp-label></h1>
        <adp-setting key="TechServices_Offerings"></adp-setting>
      </div>

  </div>
  <ng-container *ngIf="isSPOEEnabled && !isNative; else default">
    <div class="container" [ngClass]="(hasP360MobilePolicy && !hasP360HomeTechPolicy) ? 'mobile-tech-container':'tech-container'">
        <div [ngStyle]="{'margin-bottom':(hasP360MobilePolicy && !hasP360HomeTechPolicy)?'0px':'50px'}">
          <div class="scheduling-title-text-container"><adp-label labelKey="TechServices_Schedule_RemoteSession_Title"></adp-label></div>
          <div class="scheduling-desc-text-container"><adp-label labelKey="TechServices_Schedule_RemoteSession_Description"></adp-label></div>
          <div style="gap:30px;" [ngStyle]="{'display':(!isMobileSize)?'flex':''}">
            <div *ngIf="hasP360MobilePolicy">
              <button
                mat-stroked-button
                color="primary"
                *ngIf="remoteSessionMobileUrl"
                (click)="redirectToP360SchedulingUrl()"
                class="mt-3"
                [gtmClick]="getViewLabel('TechServices_SPOE_Mobile_ScheduleRemote_Button_Label')"
                [gtmLinkURL]="remoteSessionMobileUrl">
                <adp-label labelKey="TechServices_SPOE_Mobile_ScheduleRemote_Button_Label"></adp-label>
              </button>
            </div>
            <div *ngIf="hasP360HomeTechPolicy">
              <button
                mat-stroked-button
                color="primary"
                *ngIf="remoteSessionHomeTechUrl"
                (click)="redirectToPTPSchedulingUrl()"
                class="mt-3"
                [gtmClick]="getViewLabel('TechServices_SPOE_HomeTech_ScheduleRemote_Button_Label')"
                [gtmLinkURL]="remoteSessionHomeTechUrl">
                <adp-label labelKey="TechServices_SPOE_HomeTech_ScheduleRemote_Button_Label"></adp-label>
              </button>
            </div>

          </div>
        </div>
        <div>
          <ng-container *ngIf="isTechServicesSpecialOffersEnabled">
            <adp-setting key="URL_External_HelloTech"></adp-setting>
            <adp-setting key="URL_External_PTPScheduling"></adp-setting>
            <adp-setting key="URL_External_PTPScheduling_Prod"></adp-setting>
            <app-tech-services-tabs [offers]="offers"
                            [contractId]="contractId"
                            [userEmail]="userEmail"
                            [userType]="userType"
                            [usersOnContract]="usersOnContract"></app-tech-services-tabs>
          </ng-container>
        </div>
      </div>
  </ng-container>
  <ng-template #default>
    <ng-container>
      <div class="tech-container container">
        <div>
          <ng-container *ngIf="isTechServicesSpecialOffersEnabled">
            <adp-setting key="URL_External_HelloTech"></adp-setting>
            <adp-setting key="URL_External_PTPScheduling"></adp-setting>
            <adp-setting key="URL_External_PTPScheduling_Prod"></adp-setting>
            <app-tech-services-tabs [offers]="offers"
                            [contractId]="contractId"
                            [userEmail]="userEmail"
                            [userType]="userType"
                            [usersOnContract]="usersOnContract"></app-tech-services-tabs>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <div class="tech-services-page">
        <adp-setting key="TechServices_Promo_IsEnabled"></adp-setting>
        <adp-setting key="TechServices_Promo_IsPromoAppType"></adp-setting>
        <div class="fluid-container promo-wrapper" *ngIf="isTechServicesChatEnabled"
          ifSettingTrue="TechServices_Promo_IsEnabled">
          <div style="width:100%;" class="background-fill-container">
            <app-promotion-panel [isDisabledController]="isExpired" [promoSlot]="promoSlot"
              gaName="Tech Services Promotion Panel">
            </app-promotion-panel>
          </div>
        </div>
      </div>
</ng-container>
